import "./GastronomyWebsite.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import WhyChoosePpcWithZionova from "./sections/WhyChoosePpcWithZionova";
import EngineAnimation from "./sections/EngineAnimation";
import TailoredForEveryDepartment from "./sections/TailoredForEveryDepartment";
import BeispielMockup from "./sections/BeispielMockup";
import ChooseTheRightLevelOfSupport from "./sections/ChooseTheRightLevelOfSupport";
import ClientTestimonials from "./sections/ClientTestimonials";
import GetStartedCta from "./sections/GetStartedCta";
import Footer from "@/reusable_sections/Footer";
export default function GastronomyWebsitePage() {
  return <div>
      <Header />
      <Hero />
      <WhyChoosePpcWithZionova />
      <EngineAnimation />
      <TailoredForEveryDepartment />
      <BeispielMockup />
      <ChooseTheRightLevelOfSupport />
      <ClientTestimonials />
      <GetStartedCta />
      <Footer />
    </div>;
}